import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Keyboard, type KeyboardInfo } from "@capacitor/keyboard";

/**
 * 键盘（或虚拟视口）遮挡的底部高度（px），用于把 fixed 底栏顶到键盘上方。
 * - 原生：Capacitor Keyboard
 * - 浏览器：Visual Viewport API
 */
export function useKeyboardBottomInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      let showPromise: Promise<{ remove: () => void }> | undefined;
      let hidePromise: Promise<{ remove: () => void }> | undefined;
      try {
        showPromise = Keyboard.addListener("keyboardWillShow", (info: KeyboardInfo) => {
          setInset(info.keyboardHeight ?? 0);
        });
        hidePromise = Keyboard.addListener("keyboardWillHide", () => {
          setInset(0);
        });
      } catch {
        // Web 或未安装插件
      }
      return () => {
        showPromise?.then((h) => h.remove()).catch(() => {});
        hidePromise?.then((h) => h.remove()).catch(() => {});
      };
    }

    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      const h = window.innerHeight;
      setInset(Math.max(0, h - vv.height - vv.offsetTop));
    };

    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return inset;
}
